import { useContext } from 'react';

import { ErrorReportingContext } from '../../providers/context/ErrorReportingContext/ErrorReportingContext';

export const useErrorReporting = () => useContext(ErrorReportingContext);
